import { z } from 'zod';

import { actionIdSchema } from '../chat-ids';
import { sharedStructuredEventShape } from './shared';

export const HELLO_HITL_TOOL_ID = 'helloHitl';

export const questionnaireOptionSchema = z.object({
    label: z.string(),
    recommended: z.boolean().optional(),
});

export type QuestionnaireOption = z.infer<typeof questionnaireOptionSchema>;

export const questionnaireQuestionSchema = z.object({
    actionId: actionIdSchema,
    allowCustomInput: z.boolean().optional(),
    answer: z.string().optional(),
    label: z.string(),
    options: z.array(questionnaireOptionSchema).min(1),
});

export type QuestionnaireQuestion = z.infer<typeof questionnaireQuestionSchema>;

export const questionnaireBlockSchema = z.object({
    blockId: z.uuid(),
    callbackUrl: z.string().optional(),
    mode: z.string().optional(),
    questions: z.array(questionnaireQuestionSchema).min(1),
    title: z.string(),
    type: z.literal('questionnaire'),
});

export type QuestionnaireBlock = z.infer<typeof questionnaireBlockSchema>;

export const helloHitlBlockSchema = z.discriminatedUnion('type', [questionnaireBlockSchema]);

export type HelloHitlBlock = z.infer<typeof helloHitlBlockSchema>;

export const helloHitlPayloadSchema = z.object({
    blocks: z.array(helloHitlBlockSchema).min(1),
});

export type HelloHitlPayload = z.infer<typeof helloHitlPayloadSchema>;

export const helloHitlResponseEventSchema = z.object({
    ...sharedStructuredEventShape,
    payload: helloHitlPayloadSchema,
    toolId: z.literal(HELLO_HITL_TOOL_ID),
});

export type HelloHitlResponseEvent = z.infer<typeof helloHitlResponseEventSchema>;
